export default __webpack_public_path__ + "925959e4659ce3f70841063babc9273b.svg";